// src/api/api.js
import axios from "axios";
import { store } from "../../redux/Store";
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401 && !err.config?.skipAuthExpiry) {
      const state = store.getState();
      if (!state.auth.sessionExpired) {
        store.dispatch({ type: "SESSION_EXPIRED" });
      }
    }
    return Promise.reject(err);
  }
);

// Axios inherits the instance-wide JSON content type for FormData unless it is
// explicitly cleared. Let the browser add the multipart boundary automatically.
api.interceptors.request.use((config) => {
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    config.headers = config.headers || {};
    if (typeof config.headers.delete === "function") config.headers.delete("Content-Type");
    else {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  }
  return config;
});

export default api;
